export default "__VITE_PUBLIC_ASSET__f8180c9d__"